import React, { useEffect } from 'react';
import { useWatchlist } from '../useContext/WatchlistContext';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';

/**
 * Debug component to test watchlist functionality
 */
const WatchlistDebugger = () => {
  const { 
    watchlist, 
    favorites, 
    addToWatchlist, 
    addToFavorites, 
    removeFromWatchlist, 
    removeFromFavorites,
    loading,
    error
  } = useWatchlist();

  // Test movie data
  const testMovie = {
    id: 550,
    title: 'Fight Club',
    type: 'movie',
    poster_path: '/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
    imgSrc: 'https://image.tmdb.org/t/p/w500/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
    vote_average: 8.4,
    release_date: '1999-10-15',
    overview: 'A ticking-time-bomb insomniac and a slippery soap salesman channel primal male aggression into a shocking new form of therapy.',
    adult: false
  };

  const testTVShow = {
    id: 1399,
    title: 'Game of Thrones',
    type: 'tv',
    poster_path: '/u3bZgnGQ9T01sWNhyveQz0wH0Hl.jpg',
    imgSrc: 'https://image.tmdb.org/t/p/w500/u3bZgnGQ9T01sWNhyveQz0wH0Hl.jpg',
    vote_average: 8.3,
    release_date: '2011-04-17',
    overview: 'Seven noble families fight for control of the mythical land of Westeros.',
    adult: false
  };

  const handleAddToWatchlist = (item) => {
    console.log('Adding to watchlist:', item);
    addToWatchlist(item);
  };

  const handleAddToFavorites = (item) => {
    console.log('Adding to favorites:', item);
    addToFavorites(item);
  };

  const handleRemoveFromWatchlist = (item) => {
    console.log('Removing from watchlist:', item);
    removeFromWatchlist(item.id, item.type);
  };

  const handleRemoveFromFavorites = (item) => {
    console.log('Removing from favorites:', item);
    removeFromFavorites(item.id, item.type);
  };

  // Log state changes
  useEffect(() => {
    console.log('Watchlist state changed:', { watchlist, favorites, loading });
  }, [watchlist, favorites, loading]);

  // Check localStorage
  useEffect(() => {
    const watchlistStorage = localStorage.getItem('watchlist');
    const favoritesStorage = localStorage.getItem('favorites');
    console.log('localStorage watchlist:', watchlistStorage);
    console.log('localStorage favorites:', favoritesStorage);
  }, [watchlist, favorites]);

  return (
    <Container className="mt-5">
      <Row>
        <Col md="12">
          <h2 className="text-white mb-4">Watchlist Debugger</h2>
          
          {/* Status */}
          <Row className="mb-4">
            <Col md="6">
              <Card className="bg-dark text-white">
                <Card.Header>
                  <h5>Current State</h5>
                </Card.Header>
                <Card.Body>
                  <p><strong>Loading:</strong> {loading ? 'Yes' : 'No'}</p>
                  <p><strong>Watchlist Count:</strong> {watchlist.length}</p>
                  <p><strong>Favorites Count:</strong> {favorites.length}</p>
                  {error && <Alert variant="danger">Error: {error}</Alert>}
                </Card.Body>
              </Card>
            </Col>
            <Col md="6">
              <Card className="bg-dark text-white">
                <Card.Header>
                  <h5>localStorage Data</h5>
                </Card.Header>
                <Card.Body>
                  <p><strong>Watchlist Storage:</strong></p>
                  <pre className="text-muted small">
                    {localStorage.getItem('watchlist') || 'Empty'}
                  </pre>
                  <p><strong>Favorites Storage:</strong></p>
                  <pre className="text-muted small">
                    {localStorage.getItem('favorites') || 'Empty'}
                  </pre>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Test Buttons */}
          <Row className="mb-4">
            <Col md="6">
              <Card className="bg-dark text-white">
                <Card.Header>
                  <h5>Test Movie</h5>
                </Card.Header>
                <Card.Body>
                  <img 
                    src={testMovie.imgSrc} 
                    alt={testMovie.title}
                    style={{ width: '100px', height: '150px', objectFit: 'cover' }}
                    className="mb-3"
                  />
                  <h6>{testMovie.title}</h6>
                  <p className="small text-muted">{testMovie.overview.substring(0, 100)}...</p>
                  <div className="d-flex gap-2">
                    <Button 
                      variant="warning" 
                      size="sm"
                      onClick={() => handleAddToWatchlist(testMovie)}
                      disabled={loading}
                    >
                      Add to Watchlist
                    </Button>
                    <Button 
                      variant="danger" 
                      size="sm"
                      onClick={() => handleAddToFavorites(testMovie)}
                      disabled={loading}
                    >
                      Add to Favorites
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md="6">
              <Card className="bg-dark text-white">
                <Card.Header>
                  <h5>Test TV Show</h5>
                </Card.Header>
                <Card.Body>
                  <img 
                    src={testTVShow.imgSrc} 
                    alt={testTVShow.title}
                    style={{ width: '100px', height: '150px', objectFit: 'cover' }}
                    className="mb-3"
                  />
                  <h6>{testTVShow.title}</h6>
                  <p className="small text-muted">{testTVShow.overview.substring(0, 100)}...</p>
                  <div className="d-flex gap-2">
                    <Button 
                      variant="warning" 
                      size="sm"
                      onClick={() => handleAddToWatchlist(testTVShow)}
                      disabled={loading}
                    >
                      Add to Watchlist
                    </Button>
                    <Button 
                      variant="danger" 
                      size="sm"
                      onClick={() => handleAddToFavorites(testTVShow)}
                      disabled={loading}
                    >
                      Add to Favorites
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Current Watchlist */}
          <Row className="mb-4">
            <Col md="6">
              <Card className="bg-dark text-white">
                <Card.Header>
                  <h5>Current Watchlist ({watchlist.length})</h5>
                </Card.Header>
                <Card.Body>
                  {watchlist.length === 0 ? (
                    <p className="text-muted">No items in watchlist</p>
                  ) : (
                    <div className="list-group">
                      {watchlist.map((item, index) => (
                        <div key={`${item.type}-${item.id}-${index}`} className="list-group-item bg-secondary text-white mb-2">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="mb-1">{item.title}</h6>
                              <small className="text-muted">
                                {item.type} • ID: {item.id}
                              </small>
                            </div>
                            <Button 
                              variant="outline-danger" 
                              size="sm"
                              onClick={() => handleRemoveFromWatchlist(item)}
                              disabled={loading}
                            >
                              Remove
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
            <Col md="6">
              <Card className="bg-dark text-white">
                <Card.Header>
                  <h5>Current Favorites ({favorites.length})</h5>
                </Card.Header>
                <Card.Body>
                  {favorites.length === 0 ? (
                    <p className="text-muted">No items in favorites</p>
                  ) : (
                    <div className="list-group">
                      {favorites.map((item, index) => (
                        <div key={`${item.type}-${item.id}-${index}`} className="list-group-item bg-secondary text-white mb-2">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="mb-1">{item.title}</h6>
                              <small className="text-muted">
                                {item.type} • ID: {item.id}
                              </small>
                            </div>
                            <Button 
                              variant="outline-danger" 
                              size="sm"
                              onClick={() => handleRemoveFromFavorites(item)}
                              disabled={loading}
                            >
                              Remove
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Navigation Links */}
          <Row>
            <Col md="12">
              <Card className="bg-dark text-white">
                <Card.Header>
                  <h5>Test Navigation</h5>
                </Card.Header>
                <Card.Body>
                  <div className="d-flex gap-3">
                    <a href="/watchlist" className="btn btn-primary">
                      Go to Watchlist Page
                    </a>
                    <a href="/watchlist?tab=favourite" className="btn btn-danger">
                      Go to Favorites Tab
                    </a>
                    <a href="/watchlist-demo" className="btn btn-info">
                      Go to Demo Page
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default WatchlistDebugger;
